const appState = {
  loader: true,
  optionsData: { options: [], contractType: '' },
  ticketsData: [],
  loginPopup: { open: false, desc: '', login: true, nonlogin: false, click: false },
  faqData: [],
  csportalData: {},
  alertSnackbar: { message: '', status: '' },
  popupObj: { popupType: '', open: false, heading: '', subHeading: '', placeholder: '' },
  bannerTypeData: {},
  faqchangeState: false,
  validatorPopup: { open: false, desc: '', login: true, nonlogin: false, click: false },
  tagsFeedbackPage: { status: false, question: '' },
};

const appStateReducer = (state, action = {}) => {
  const { payload, type } = action;
  switch (type) {
    case 'LOADER': {
      return {
        ...state,
        loader: payload.loader,
      };
    }
    case 'SET_OPTIONS_DATA': {
      return {
        ...state,
        optionsData: payload.optionsData,
      };
    }
    case 'SET_TICKETS_DATA': {
      return {
        ...state,
        ticketsData: payload.ticketsData,
      };
    }
    case 'SET_FAQ_DATA': {
      return {
        ...state,
        faqData: payload.faqData,
      };
    }
    case 'SET_CSPORTAL_DATA': {
      return {
        ...state,
        csportalData: payload.csportalData,
      };
    }
    case 'ALERT_SNACKBAR': {
      return {
        ...state,
        alertSnackbar: payload,
      };
    }
    case 'SET_POPUP': {
      return {
        ...state,
        popupObj: payload,
      };
    }
    case 'SET_BANNER_TYPE_DATA': {
      return {
        ...state,
        bannerTypeData: payload.bannerTypeData,
      };
    }
    case 'LOGIN_POPUP': {
      return {
        ...state,
        loginPopup: payload,
      };
    }
    case 'VALIDATOR_POPUP': {
      return {
        ...state,
        validatorPopup: payload,
      };
    }
    case 'FAQ_CHANGE': {
      return {
        ...state,
        faqchangeState: payload,
      };
    }
    case 'SHOW_FEEDBACK_PAGE': {
      return {
        ...state,
        tagsFeedbackPage: payload,
      };
    }
    default:
      return state;
  }
};

export { appState, appStateReducer };
